<template>
  <q-dialog v-model="visible" no-backdrop-dismiss no-esc-dismiss color="secondary" @ok="onOk" @cancel="onCancel">
    <q-card style="width: 650px; max-width: 650px;">
      <q-card-section>
        <h6 class="q-card-title">
          <slot :data="entity" name="custom-title">
            Confirm {{ entity.name ? `deletion of ${entity.name}` : '' }}
          </slot>
        </h6>
        <template v-if="dialogData">
          <q-list>
            <q-item v-for="message in dialogData.getMessages()" :key="message">{{ message }}</q-item>
          </q-list>
        </template>
      </q-card-section>
      <q-card-section>
        <div
          :class="dialogData && dialogData.isReplaceable() ? 'items-center justify-center' : 'justify-start'"
          class="row"
        >
          <template v-if="dialogData && dialogData.isReplaceable()">
            <div class="col-6">
              <slot name="replaceable-options">
                <enhanced-q-select
                  v-if="replacementOptions.length > 0"
                  id="replacement-select"
                  v-model="replaceWith"
                  dense
                  :options="replacementOptions"
                  class="no-vertical-margin no-horizontal-margin"
                  label="Replacement"
                />
              </slot>
            </div>
            <slot :data="dialogData" name="replaceable-actions">
              <div class="col-auto q-mr-md q-ml-md">
                <q-btn
                  v-if="dialogData.isConfirmable()"
                  :label="
                    replaceWith ? `Replace and delete` : replacementOptions.length > 0 ? `Delete anyway` : `Confirm`
                  "
                  color="negative"
                  @click="onOk"
                />
              </div>
              <div class="col-auto q-mr-md">
                <q-btn flat label="Cancel" @click="onCancel" />
              </div>
            </slot>
          </template>
          <slot v-else :data="dialogData" name="non-replaceable-actions">
            <div class="col-auto q-mb-md q-pr-md">
              <q-btn
                v-if="dialogData && dialogData.isConfirmable() && !dialogData.isReplaceable()"
                color="negative"
                label="Confirm"
                @click="onOk"
              />
              <q-btn flat label="Cancel" @click="onCancel" />
            </div>
          </slot>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import EnhancedQSelect from '@components/general/EnhancedQSelect'
import { get } from 'lodash'

export default {
  name: 'LmDialog',
  components: {
    EnhancedQSelect
  },
  props: {
    storeNamespace: {
      type: String,
      required: false,
      default: ''
    },
    entity: {
      type: Object,
      required: false,
      default: () => {}
    },
    callback: {
      type: [Function, null],
      required: false,
      default: null
    },
    uid: {
      type: String,
      required: true
    },
    replacementOptions: {
      type: [Array, null],
      required: false,
      default: null
    },
    handleConfirmOnParent: Boolean
  },
  data() {
    return {
      replaceWith: null
    }
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.globalDialogVisible[this.uid]
      },
      set(value) {
        this.$store.commit('updateGlobalDialogVisibility', {
          uid: this.uid,
          value
        })
      }
    },
    dialogData() {
      return get(this.$store.state.globalDialogContent, `${this.uid}`, null)
    }
  },
  mounted() {
    this.$store.commit('updateGlobalDialogVisibility', {
      uid: this.uid,
      value: false
    })
  },
  methods: {
    onOk() {
      if (this.handleConfirmOnParent) {
        this.$emit('confirm')
        return
      }
      let params = { id: this.entity.id }
      if (this.dialogData.isReplaceable() && this.replaceWith) params.replaceWith = this.replaceWith

      this.$q.loading.show({
        delay: 400 // ms
      })
      return this.$store
        .dispatch(`${this.storeNamespace}/${this.dialogData.getConfirmAction()}`, params)
        .then(() => {
          typeof this.callback === 'function' ? this.callback() : this.$emit('done')
          this.replaceWith = null
          return this.$store.dispatch('updateGlobalDialogVisibility', {
            uid: this.uid,
            value: false
          })
        })
        .finally(() => {
          this.$q.loading.hide()
        })
    },
    onCancel() {
      this.handleConfirmOnParent && this.$emit('cancel')
      return this.$store.dispatch('updateGlobalDialogVisibility', {
        uid: this.uid,
        value: false
      })
    }
  }
}
</script>
